<!-- program 模板列表 -->
<template>
  <div class="ProgramTemplateList">
    <!-- 项目模板 -->
    <div class="ProgramTemplateTop">
      <div class="searchTitle">
          <el-tooltip
            placement="top"
            effect="light"
            popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.search") }}</div>
            </div>
            <i
            class="iconfont icon-search pointer"
            @click="searchShow"
            :title="$t('lang.search')"></i>
          </el-tooltip>
          <el-tooltip
            placement="top"
            effect="light"
            popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.addFolder") }}</div>
            </div>
            <i
              :disabled="CloneDisabled.Media"
              class="iconfont icon-addfolder"
              @click="showAddFolder"></i>
          </el-tooltip>
          <el-tooltip
            placement="top"
            effect="light"
            popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.addSchedule") }}</div>
            </div>
            <i
            class="iconfont icon-add pointer"
            @click="addProgram"
            :disabled="CloneDisabled.disableButton"
            ></i>
          </el-tooltip>
      </div>
      <!-- 搜索框 -->
      <div
        class="searchInput"
        v-if="fileInput">
        <el-input
          ref="ResourceSearch"
          v-model="PTemplateCondition"
          :placeholder="$t('lang.fileName')"
          @keyup.enter.native="searchProgramList(false, 'search')"></el-input>
        <i
          class="iconfont icon-search pointer"
          @click="searchProgramList(false, 'search')"></i>
      </div>
    </div>
    <div class="AllTemplateWrap" id="AllTemplateWrap"  v-loading='programTemplateLoading'>
      <el-collapse v-model="activeName" @change="handleChange">
        <el-collapse-item :name="TemplateItem.type" v-for="TemplateItem in TemplateClassifyConfig" :key="TemplateItem.type">
          <template slot="title">
            <i v-if="!TemplateItem.switch" class="el-icon-caret-right"></i> <i v-else class="el-icon-caret-bottom"></i>{{$t(TemplateItem.name)}}{{` (${TemplateItem.params.total})`}}
          </template>
          <PTemplate-list-tree
            v-if="TemplateItem.type == 'NativeTemplates'"
            :TemplateList="TemplateData.NativeTemplates"
            :TemplateType="TemplateType"
            @EditDelete="EditDelete"
          ></PTemplate-list-tree>
          <PTemplate-scroll-load
            v-if="TemplateItem.type == 'AmazonS3Templates'"
            :key="TemplateItem.type"
            :TemplateType="TemplateItem.type"
            :TemplateData="TemplateData[TemplateItem.type]"
            @ScrollUpdateTemplate="ScrollUpdateTemplate"
            @deleteTemplate="deleteTemplate"
            @editTemplate="editTemplate"
            ></PTemplate-scroll-load>
        </el-collapse-item>
      </el-collapse>
    </div>
    <EditTemplateFolder
      v-if="editFolder.show"
      :ConfigParam="editFolder"
      @queryFolder="getProgramList"
    ></EditTemplateFolder>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
import { componentsAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import { mapState } from 'vuex'
import PTemplateScrollLoad from './PTemplateScrollLoad.vue'
import PTemplateListTree from './PTemplateListTree.vue'
import EditTemplateFolder from '@/components/file/EditTemplateFolder'

export default {
  data () {
    return {
      // 模板文件搜素
      fileInput: false,
      // 模板列表
      programTemplateList: [],
      // 搜索
      PTemplateCondition: '',
      // loadding
      programTemplateLoading: false,
      // 模板配置
      TemplateClassifyConfig: [
        {
          name: 'lang.NativeTemplates',
          type: 'NativeTemplates',
          switch: true,
          loadding: false,
          params: {
            pageNum: 1,
            pageSize: 12,
            total: 0,
            nextPage: false
          }
        },
        {
          name: 'lang.AmazonS3Templates',
          type: 'AmazonS3Templates',
          switch: false,
          loadding: false,
          params: {
            pageNum: 1,
            pageSize: 12,
            total: 0,
            nextPage: false
          }
        }
      ],
      // 模板数据
      TemplateData: {
        NativeTemplates: [],
        AmazonS3Templates: []
      },
      // 父文件夹信息
      parentFolder: {},
      // 模板树是正常列表还是搜索
      TemplateType: 'list',
      // 打开的树
      activeName: [],
      // 文件夹的操作信息
      editFolder: {
        show: false,
        name: '',
        parentId: '',
        id: '',
        type: 0
      },
      programId: ''
    }
  },
  components: {
    PTemplateScrollLoad,
    PTemplateListTree,
    EditTemplateFolder
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {
    Bus.$on('refreshTemList', (tag) => {
      this.getProgramList(false)
    })
  },
  mounted () {
    this.programId = this.$BehaviorSyns.getProgramId()
    this.getProgramList()
    this.getS3ProgramList()
    this.activeName = ['NativeTemplates']
  },
  methods: {
    // 搜索模板
    searchShow () {
      componentsAnalyze('programTemplateListSearchShow', '/ponent')
      this.fileInput = !this.fileInput
      if (!this.fileInput) {
        this.PTemplateCondition = ''
        this.getProgramList()
        this.getS3ProgramList()
      } else {
        this.$nextTick(() => {
          this.$refs.ResourceSearch.focus()
        })
      }
    },
    // source展开
    handleChange () {
      this.TemplateClassifyConfig.forEach((item) => {
        if (this.activeName.includes(item.type)) {
          item.switch = true
        } else {
          item.switch = false
        }
      })
    },
    // 模板文件夹编辑删除
    EditDelete (data) {
      console.log(data)
      // 文件
      if (data.directory) {
        if (data.type == 'edit') {
          this.editTemplate(data.data)
        } else {
          this.deleteTemplate(data.data)
        }
      // 文件夹
      } else {
        if (data.type == 'edit') {
          this.editFolder = {
            show: true,
            ...data.data,
            type: 1
          }
        } else {
          this.deleteFolder(data.data)
        }
      }
    },
    // 新增文件夹
    showAddFolder () {
      if (this.CloneDisabled.Media) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderAddFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderAddFolder', '/pop')
      }
      if (!this.parentFolder.id) return
      this.editFolder = {
        show: true,
        name: '',
        parentId: this.parentFolder.id,
        type: 0
      }
    },
    // 删除文件夹
    deleteFolder (data) {
      const deleteTemplateFolder = data.mediaCount ? this.$t('lang.deleteTemplateFolder2', { name: data.name, num: data.mediaCount }) : this.$t('lang.deleteTemplateFolder', { name: data.name })
      this.$confirm(deleteTemplateFolder, '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const Url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/deleteEventTemplateFolder'
        const params = {
          folderId: data.id,
          programId: this.programId
        }
        this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.deleteSuccess'))
            this.getProgramList()
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // 添加模板
    addProgram () {
      if (this.CloneDisabled.disableButton) return
      componentsAnalyze('programTemplateListAddProgram', '/ponent')
      this.$emit('editTemplate', {
        status: true,
        name: 'programTemplate'
      })
      Bus.$emit('goTemplateBlank', {
        tag: 'tem',
        type: 'add',
        data: {}
      }, false)
    },
    // 编辑模板
    editTemplate (item) {
      componentsAnalyze('programTemplateListEditTemplate', '/ponent')
      NotManyEdit.checkUserEdit({ type: 1, logicId: item.id }).then((res) => {
        if (res) {
          this.$emit('editTemplate', {
            status: true,
            name: 'programTemplate',
            data: item
          })
          this.$nextTick(() => {
            Bus.$emit('goTemplateBlank', {
              data: item,
              tag: 'tem',
              type: 'edit'
            }, true)
          })
        }
      })
    },
    // 删除模板
    deleteTemplate (item) {
      componentsAnalyze('programTemplateListDeleteTemplate', '/ponent')
      this.$confirm(this.$t('lang.deleteTemplate'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const Url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/delete'
        const params = {
          ids: [item.id]
        }
        this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.deleteSuccess'))
            Bus.$emit('closeTemplate', item.id)
            this.getProgramList()
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // 绑定滚动加载
    ScrollUpdateTemplate (type) {
      // if (type == 'NativeTemplates') {
      //   if (this.TemplateClassifyConfig[0].params.nextPage) {
      //     this.TemplateClassifyConfig[0].params.pageNum++
      //     this.getProgramList(true)
      //   }
      // } else
      if (type == 'AmazonS3Templates') {
        if (this.TemplateClassifyConfig[1].params.nextPage) {
          this.TemplateClassifyConfig[1].params.pageNum++
          this.getS3ProgramList(true)
        }
      }
    },
    // 搜索模板
    searchProgramList (queryType, getMode) {
      if (getMode == 'search') {
        this.PTemplateCondition = this.PTemplateCondition.replace(/(^\s*)|(\s*$)/g, '')
      }
      this.getProgramList(getMode)
      this.getS3ProgramList(queryType, getMode)
    },
    // 获取paogram模板列表
    getProgramList (getMode) {
      componentsAnalyze('programTemplateListGetProgramList', '/ponent')
      this.programTemplateLoading = true
      const params = {
        condition: '',
        programId: this.programId
      }
      if (getMode == 'search') {
        params.condition = this.PTemplateCondition
      }
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/eventTemplate/page',
          params
        )
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              const list = res.data.result ? res.data.result : {}
              this.parentFolder = {
                driveId: list.driveId,
                id: list.id,
                objectKey: list.objectKey
              }
              this.TemplateClassifyConfig[0].params.total = list.mediaCount
              if (getMode != 'search') {
                this.TemplateData.NativeTemplates = list.floderAndPGMTemplateList ? list.floderAndPGMTemplateList : []
                this.TemplateData.NativeTemplates.forEach((item) => {
                  if (!item.directory && (item.floderAndPGMTemplateList == null || item.floderAndPGMTemplateList.length == 0)) {
                    item.floderAndPGMTemplateList = [
                      {
                        noData: true,
                        directory: true
                      }
                    ]
                  }
                })
                this.TemplateType = 'list'
              } else {
                this.TemplateData.NativeTemplates = list.floderAndPGMTemplateList ? list.floderAndPGMTemplateList : []
                this.TemplateType = 'search'
              }
              this.programTemplateLoading = false
              Bus.$emit('leftListUpdate')
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
              this.programTemplateLoading = false
            }
          }
        }).catch(() => {})
    },
    // 获取S3paogram模板列表
    getS3ProgramList (queryType, getMode) {
      componentsAnalyze('programTemplateListGetProgramList', '/ponent')
      let params = {}
      if (!queryType || getMode == 'search') {
        this.TemplateClassifyConfig[1].params.pageNum = 1
        this.TemplateClassifyConfig[1].params.nextPage = false
      }
      params = JSON.parse(JSON.stringify(this.TemplateClassifyConfig[1].params))
      if (getMode == 'search') {
        params.condition = this.PTemplateCondition
        params.pageSize = 1000
      }
      params.programId = this.programId
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/eventTemplate/pageExternal',
          params
        )
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.TemplateClassifyConfig[1].params.nextPage = res.data.result.hasNextPage
              this.TemplateClassifyConfig[1].params.total = res.data.result.total
              if (!res.data.result.list) res.data.result.list = []
              if (queryType) {
                this.TemplateData.AmazonS3Templates.push(...res.data.result.list)
              } else {
                this.TemplateData.AmazonS3Templates = res.data.result.list
              }
              Bus.$emit('leftListUpdate')
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
.ProgramTemplateList {
  height: 100%;
  .ProgramTemplateTop {
    .searchTitle {
      padding: 12px 0 10px 0;
      border-bottom: 2px solid #555;
      text-align: right;
      i {
        margin: 0 4px;
        color: #cccccc;
      }
    }
    .searchInput {
      position: relative;
      ::v-deep .el-input__inner {
        padding-right: 45px;
      }
      i {
        position: absolute;
        right: 12px;
        font-size: 20px;
        top: 7px;
        z-index: 1001;
      }
    }
  }
  .AllTemplateWrap{
    height: calc(100% - 50px);
    overflow-y: auto;
    ::v-deep .el-collapse{
      border: none;
      .el-collapse-item__header{
        background-color: #444444;
        border: none;
        color: #dfdfdf;
        height: 32px;
        line-height: 32px;
        i{
          margin-right: 5px;
        }
        .el-icon-arrow-right{
          display: none;
        }
      }
      .el-collapse-item__wrap{
        background-color: #444444;
        border: none;
        .el-collapse-item__content{
          padding-bottom: 0px;
        }
      }
    }
  }
  #AllTemplateWrap::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
  }
}
</style>
